var audio_rtlignore_default = {
  "fontElementMap": "Ox-Sy",
  "container": "vs3Ij",
  "customPlayer": "CUcsP",
  "slim": "U-bkY",
  "playPauseButton": "HT1Z8",
  "coverImage": "awJeq",
  "trackDetailsContainer": "zRtQg",
  "controlsContainer": "a3WHW",
  "controlsGroup": "tUR3E",
  "sliderContainer": "ceXVz",
  "audioDuration": "_2aWyu",
  "isLoading": "_1tW7j",
  "audioDetails": "-zkgr",
  "authorName": "shcj-",
  "title": "_5H-Gp",
  "dropdownMenuWrapper": "fCLDy",
  "dropdownSelectedButton": "gWrA-",
  "dropdownContent": "fYXNp",
  "dropdownContentWithIcon": "Dwzfs",
  "audioLoader": "J7q9O"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
